import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";
import { FragmentFields } from "@scrile/api-provider/dist/api/types";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";

export type GroupWithUser = Pick<
  Group,
  "id" | "ownerId" | "name" | "memberIds" | "system" | "createTime" | "updateTime"
> & {
  members: (UserPublicData | null)[];
};

export const USER_FRAGMENT: FragmentFields<UserPublicData> = [
  "id",
  "screenName",
  "username",
  "vipStatus",
  { onlineStatus: ["isOnline"] },
  { avatar: ["urlPart", "uuid", "updateTime", "metadata"] },
  { subscriptionToMe: ["amount", { recurringBillingSchedule: ["cancelled"] }] },
];

export function notEmpty<T>(value: T | null): value is T {
  return value !== null;
}
